export function userAttribs(): string | null {
  const lastAuthUser = localStorage.getItem(
    `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID}.LastAuthUser`
  );
  const attribs = localStorage.getItem(
    `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOL_WEB_CLIENT_ID}.${lastAuthUser}.userData`
  );
  return attribs;
}
